import React, { useState } from 'react';
const inputStyle: React.CSSProperties = {
  fontFamily: 'Inter, sans-serif',
  fontSize: '15px',
  color: '#025A8A',
  backgroundColor: '#ffffff',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  minHeight: '44px',
  padding: '10px 14px',
  width: '100%',
  outline: 'none'
};
export function ContactForm() {
  const [form, setForm] = useState({
    inquiryType: '',
    firstName: '',
    lastName: '',
    phone: '',
    email: '',
    message: '',
    consent1: false,
    consent2: false
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      checked
    } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: checked
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert('Thank you! We will get back to you shortly.');
  };
  return <form onSubmit={handleSubmit} className="flex flex-col gap-5" data-id="element-48">
      <h3 className="font-bold mb-2" style={{
      color: '#0283C7',
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 900,
      fontSize: '24px',
      lineHeight: 1.2
    }} data-id="element-49">
        Send Us a Message
      </h3>

      {/* Inquiry Type */}
      <div data-id="element-50">
        <label className="block text-sm font-medium mb-1.5" style={{
        color: '#025A8A',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-51">
          Type of Inquiry
        </label>
        <select name="inquiryType" value={form.inquiryType} onChange={handleChange} style={{
        ...inputStyle,
        appearance: 'none',
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23025A8A' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 14px center'
      }} required data-id="element-52">
          <option value="" data-id="element-53">Select an option</option>
          <option value="services" data-id="element-54">Services</option>
          <option value="sales" data-id="element-55">Sales</option>
          <option value="residential" data-id="element-56">Residential</option>
          <option value="commercial" data-id="element-57">Commercial</option>
        </select>
      </div>

      {/* Name Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-58">
        <div data-id="element-59">
          <label className="block text-sm font-medium mb-1.5" style={{
          color: '#025A8A',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-60">
            First Name
          </label>
          <input type="text" name="firstName" value={form.firstName} onChange={handleChange} placeholder="First name" style={inputStyle} required data-id="element-61" />
        </div>
        <div data-id="element-62">
          <label className="block text-sm font-medium mb-1.5" style={{
          color: '#025A8A',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-63">
            Last Name
          </label>
          <input type="text" name="lastName" value={form.lastName} onChange={handleChange} placeholder="Last name" style={inputStyle} required data-id="element-64" />
        </div>
      </div>

      {/* Phone & Email Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-65">
        <div data-id="element-66">
          <label className="block text-sm font-medium mb-1.5" style={{
          color: '#025A8A',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-67">
            Phone
          </label>
          <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="(480) 000-0000" style={inputStyle} required data-id="element-68" />
        </div>
        <div data-id="element-69">
          <label className="block text-sm font-medium mb-1.5" style={{
          color: '#025A8A',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-70">
            Email
          </label>
          <input type="email" name="email" value={form.email} onChange={handleChange} placeholder="you@example.com" style={inputStyle} required data-id="element-71" />
        </div>
      </div>

      {/* Message */}
      <div data-id="element-72">
        <label className="block text-sm font-medium mb-1.5" style={{
        color: '#025A8A',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-73">
          Message
        </label>
        <textarea name="message" value={form.message} onChange={handleChange} placeholder="Tell us about your project..." rows={4} style={{
        ...inputStyle,
        minHeight: '120px',
        resize: 'vertical'
      }} required data-id="element-74" />
      </div>

      {/* Consent 1 */}
      <label className="flex items-start gap-3 cursor-pointer" data-id="element-75">
        <input type="checkbox" name="consent1" checked={form.consent1} onChange={handleCheck} className="mt-1 flex-shrink-0" style={{
        width: '18px',
        height: '18px',
        accentColor: '#0283C7'
      }} required data-id="element-76" />
        <span style={{
        color: '#025A8A',
        fontFamily: 'Inter, sans-serif',
        fontSize: '13px',
        lineHeight: 1.6
      }} data-id="element-77">
          By checking this box, I agree to Blue Cactus Power Washing's Terms
          &amp; Conditions and Privacy Policy. I consent to receive further
          communications by electronic means (Email/SMS) for my account,
          project, notifications, marketing purposes, and/or other services.
        </span>
      </label>

      {/* Consent 2 */}
      <label className="flex items-start gap-3 cursor-pointer" data-id="element-78">
        <input type="checkbox" name="consent2" checked={form.consent2} onChange={handleCheck} className="mt-1 flex-shrink-0" style={{
        width: '18px',
        height: '18px',
        accentColor: '#0283C7'
      }} required data-id="element-79" />
        <span style={{
        color: '#025A8A',
        fontFamily: 'Inter, sans-serif',
        fontSize: '13px',
        lineHeight: 1.6
      }} data-id="element-80">
          By providing your phone number, I agree to receive text messages from
          BCPW. Message and data rates may apply. Message frequency varies. For
          help, reply HELP. To unsubscribe, send STOP.
        </span>
      </label>

      {/* Submit */}
      <button type="submit" className="w-full text-white text-base text-center rounded-lg transition-all hover:opacity-90 hover:shadow-lg" style={{
      backgroundColor: '#0283C7',
      minHeight: '54px',
      borderRadius: '8px',
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700
    }} data-id="element-81">
        Submit
      </button>
    </form>;
}